/*
 * Three Strands redesign: Resilience Bra product page behaviour.
 *
 * - <ts-gallery>: photos follow the selected colour; thumbnails on laptop, swipe on phone.
 * - Bundle / Single cards: switch between the two purchase panels on the page.
 * - Sticky buy bar: appears once the buy buttons scroll out of view.
 *
 * Adding to cart is left entirely to the theme's own <product-form> and <variant-selects>.
 */
(function () {
  if (window.tsProductLoaded) return;
  window.tsProductLoaded = true;

  var desktop = window.matchMedia('(min-width: 990px)');

  function selectedColor(panel) {
    var input = panel.querySelector('.ts-options__group--color input:checked');
    return input ? input.value.trim().toLowerCase() : '';
  }

  // Bundle: the line under the swatches naming the two bras, e.g. "Black Resilience Bra x2".
  function updateContents(panel) {
    var line = panel.querySelector('[data-ts-bundle-contents]');
    var input = panel.querySelector('.ts-options__group--color input:checked');
    if (!line || !input) return;
    var parts = input.value.split('/').map(function (part) {
      return part.trim();
    });
    if (parts.length !== 2) return;
    line.textContent =
      parts[0] === parts[1]
        ? line.dataset.double.replace('[a]', parts[0])
        : line.dataset.pair.replace('[a]', parts[0]).replace('[b]', parts[1]);
  }

  function selectedValues(panel) {
    return Array.prototype.map.call(panel.querySelectorAll('.ts-options__group'), function (group) {
      var input = group.querySelector('input:checked');
      return input ? input.value : '';
    }).filter(Boolean);
  }

  class TsGallery extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('.ts-gallery__track');
      this.thumbsEl = this.querySelector('[data-ts-thumbs]');
      this.slides = Array.prototype.slice.call(this.track.children);
      this.active = 0;
      this.buildThumbs();

      var self = this;
      var timer;
      this.track.addEventListener(
        'scroll',
        function () {
          clearTimeout(timer);
          timer = setTimeout(function () {
            self.syncFromScroll();
          }, 80);
        },
        { passive: true }
      );
      desktop.addEventListener('change', function () {
        self.show(self.active, false);
      });

      var panel = this.closest('.ts-product');
      this.filter(panel ? selectedColor(panel) : '');
    }

    buildThumbs() {
      var self = this;
      var label = this.dataset.thumbLabel || '';
      this.thumbs = this.slides.map(function (slide, index) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'ts-gallery__thumb';
        button.setAttribute('aria-label', label.replace('[n]', index + 1));
        var source = slide.querySelector('img');
        var video = slide.querySelector('video');
        if (video) button.classList.add('ts-gallery__thumb--video');
        if (source || (video && video.poster)) {
          var img = document.createElement('img');
          var small = source ? (source.getAttribute('srcset') || '').split(',')[0].trim().split(' ')[0] : '';
          img.src = small || (source ? source.src : video.poster);
          img.alt = '';
          img.loading = 'lazy';
          img.width = 64;
          img.height = 64;
          button.appendChild(img);
        }
        button.addEventListener('click', function () {
          self.show(index, true);
        });
        self.thumbsEl.appendChild(button);
        return button;
      });
    }

    filter(color) {
      var matched = 0;
      this.slides.forEach(function (slide, index) {
        var colors = (slide.dataset.tsColors || '').split('|').filter(Boolean);
        var match = !color || colors.length === 0 || colors.indexOf('all') !== -1 || colors.indexOf(color) !== -1;
        slide.hidden = !match;
        this.thumbs[index].hidden = !match;
        if (match) matched++;
      }, this);

      if (matched === 0) {
        this.slides.forEach(function (slide, index) {
          slide.hidden = false;
          this.thumbs[index].hidden = false;
        }, this);
      }

      var first = this.slides.findIndex(function (slide) {
        return !slide.hidden;
      });
      this.show(first === -1 ? 0 : first, false);
    }

    show(index, userInitiated) {
      var slide = this.slides[index];
      if (!slide) return;
      this.active = index;

      this.slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === index);
      });
      this.thumbs.forEach(function (t, i) {
        t.setAttribute('aria-current', i === index ? 'true' : 'false');
      });

      if (!desktop.matches && this.offsetParent !== null) {
        this.track.scrollTo({
          left: slide.offsetLeft - this.track.offsetLeft,
          behavior: userInitiated ? 'smooth' : 'auto',
        });
      }

      this.dispatchEvent(new CustomEvent('ts:gallery-change', { bubbles: true }));
    }

    syncFromScroll() {
      if (desktop.matches) return;
      var left = this.track.scrollLeft;
      var closest = this.active;
      var best = Infinity;
      this.slides.forEach(function (slide, index) {
        if (slide.hidden) return;
        var distance = Math.abs(slide.offsetLeft - this.track.offsetLeft - left);
        if (distance < best) {
          best = distance;
          closest = index;
        }
      }, this);
      if (closest !== this.active) {
        this.active = closest;
        this.thumbs.forEach(function (t, i) {
          t.setAttribute('aria-current', i === closest ? 'true' : 'false');
        });
        this.dispatchEvent(new CustomEvent('ts:gallery-change', { bubbles: true }));
      }
    }

    activeImageSrc() {
      var slide = this.slides[this.active];
      var img = slide && slide.querySelector('img');
      if (img) return img.currentSrc || img.src;
      var video = slide && slide.querySelector('video');
      return (video && video.poster) || '';
    }
  }

  if (!customElements.get('ts-gallery')) customElements.define('ts-gallery', TsGallery);

  /* ---------- Panels ---------- */

  function panels() {
    return Array.prototype.slice.call(document.querySelectorAll('.ts-product'));
  }

  function activePanel() {
    return panels().find(function (p) {
      return !p.hidden;
    });
  }

  function updateSticky(panel) {
    var bar = panel.querySelector('[data-ts-sticky]');
    if (!bar) return;

    var summary = bar.querySelector('[data-ts-sticky-summary]');
    if (summary) {
      summary.textContent = [summary.dataset.tsKind].concat(selectedValues(panel)).join(' · ');
    }

    var prices = bar.querySelectorAll('[data-ts-sticky-price]');
    var source = panel.querySelector('.ts-product__price .price__sale:not(.hidden) .price-item--sale, .ts-product__price .price__regular .price-item--regular');
    var onSale = panel.querySelector('.ts-product__price .price--on-sale');
    if (onSale) source = onSale.querySelector('.price-item--sale') || source;
    if (source && source.textContent.trim()) {
      prices.forEach(function (price) {
        price.textContent = source.textContent.trim();
      });
    }

    var thumb = bar.querySelector('[data-ts-sticky-thumb]');
    var gallery = panel.querySelector('ts-gallery');
    if (thumb && gallery && gallery.activeImageSrc) {
      var src = gallery.activeImageSrc();
      if (src) thumb.style.backgroundImage = 'url("' + src + '")';
    }
  }

  function setStickyVisible(panel, visible) {
    var bar = panel.querySelector('[data-ts-sticky]');
    if (!bar) return;
    bar.classList.toggle('is-visible', visible);
    bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    var button = bar.querySelector('[data-ts-sticky-add]');
    if (button) button.tabIndex = visible ? 0 : -1;
  }

  var observer = null;

  function observeBuyArea() {
    if (observer) observer.disconnect();
    panels().forEach(function (p) {
      setStickyVisible(p, false);
    });
    var panel = activePanel();
    if (!panel || !('IntersectionObserver' in window)) return;
    var area = panel.querySelector('[data-ts-buy-area]');
    if (!area) return;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        setStickyVisible(panel, !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    });
    observer.observe(area);
  }

  function switchTo(target, fromButton) {
    var current = fromButton.closest('.ts-product');
    var next = document.querySelector('.ts-product[data-ts-panel="' + target + '"]');
    if (!next || next === current) return;

    current.hidden = true;
    next.hidden = false;

    var idInput = next.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    var url = next.dataset.tsUrl + (idInput && idInput.value ? '?variant=' + idInput.value : '');
    window.history.replaceState(window.history.state, '', url);

    var gallery = next.querySelector('ts-gallery');
    if (gallery && gallery.show) gallery.show(gallery.active || 0, false);
    updateSticky(next);
    observeBuyArea();

    var sameCard = next.querySelector('[data-ts-switch="' + target + '"]');
    if (sameCard) sameCard.focus({ preventScroll: true });
  }

  function init() {
    panels().forEach(function (panel) {
      panel.addEventListener('change', function (event) {
        if (!event.target.closest('variant-selects')) return;
        var gallery = panel.querySelector('ts-gallery');
        if (gallery && gallery.filter && event.target.closest('.ts-options__group--color')) {
          gallery.filter(selectedColor(panel));
        }
        if (event.target.closest('.ts-options__group--color')) updateContents(panel);
        updateSticky(panel);
      });

      panel.addEventListener('ts:gallery-change', function () {
        updateSticky(panel);
      });

      var price = panel.querySelector('.ts-product__price');
      if (price && 'MutationObserver' in window) {
        new MutationObserver(function () {
          updateSticky(panel);
        }).observe(price, { childList: true, subtree: true, characterData: true });
      }

      var add = panel.querySelector('[data-ts-sticky-add]');
      if (add) {
        add.addEventListener('click', function () {
          var submit = panel.querySelector('form[data-type="add-to-cart-form"] [name="add"]');
          if (submit && !submit.disabled) {
            submit.click();
          } else {
            var area = panel.querySelector('[data-ts-buy-area]');
            if (area) area.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }

      updateSticky(panel);
    });

    document.addEventListener('click', function (event) {
      var card = event.target.closest('[data-ts-switch]');
      if (!card) return;
      switchTo(card.dataset.tsSwitch, card);
    });

    observeBuyArea();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
